const storagePrefix = 'msw-db';

const storage = {
  // ---------------------------------------------------------------------------
  // AUTH TOKEN
  // ---------------------------------------------------------------------------
  setToken: (token) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  },

  getToken: () => {
    const token = window.localStorage.getItem(`${storagePrefix}token`);
    return token ? JSON.parse(token) : null;
  },

  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
  },

  // ---------------------------------------------------------------------------
  // USER DATA
  // ---------------------------------------------------------------------------
  setUserPhoneNumber: (phoneNumber) => {
    window.localStorage.setItem(`${storagePrefix}userPhoneNumber`, phoneNumber);
  },

  getUserPhoneNumber: () => {
    return window.localStorage.getItem(`${storagePrefix}userPhoneNumber`);
  },

  // ---------------------------------------------------------------------------
  // DEVICE FINGERPRINT
  // ---------------------------------------------------------------------------
  setDeviceFingerprint: (fingerprint) => {
    window.localStorage.setItem(`${storagePrefix}deviceFingerprint`, fingerprint);
  },

  getDeviceFingerprint: () => {
    return window.localStorage.getItem(`${storagePrefix}deviceFingerprint`);
  },

  clearDeviceFingerprint: () => {
    window.localStorage.removeItem(`${storagePrefix}deviceFingerprint`);
  },

  // ---------------------------------------------------------------------------
  // CLEAR ALL AUTH DATA
  // ---------------------------------------------------------------------------
  clearAuth: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
    window.localStorage.removeItem(`${storagePrefix}userPhoneNumber`);
    // fingerprint intentionally retained
  },
};

export default storage;
